// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".equipment-add-modal .form-group {\n  margin: 0 0 10px 0;\n}\n.equipment-add-modal .form-group input {\n  width: 325px;\n}\n.equipment-add-modal .form-group div textarea {\n  width: 325px !important;\n  height: 50px !important;\n}", ""]);
// Exports
module.exports = exports;
